export default __webpack_public_path__ + "static/media/ConfinedSpacePermit.57dde7d0.pdf";